import Vue from 'vue';

export default {
    namespaced: true,

    state: {
        texts: {},
        list: [],
        types: {
            0: 'Texte',
            1: 'Automatische E-Mails',
            2: 'E-Mail Vorlagen',
            3: 'Bewerbung Feldhinweise',
            4: 'Fundraising Dokumente',
            5: 'Briefe',
        },
        domains: {
            0: 'Global',
            1: 'Community',
            2: 'Bewerbertool',
        },
    },

    mutations: {
        setTexts(state, texts) {
            state.texts = texts;
        },

        setText(state, {identifier, text}) {
            Vue.set(state.texts, identifier, text);
        },

        setList(state, list) {
            state.list = list;
        },
    },

    getters: {
        getTexts(state) {
            return state.texts;
        },

        getList(state) {
            return state.list;
        },

        getTypes(state) {
            return state.types;
        },

        getText(state) {
            return identifier => {
                // no magic needed so far, but maybe some day we need to replace placeholders in the text.
                return state.texts[identifier];
            };
        },

        getListText(state) {
            return identifier => {
                return state.list.find(e => e.identifier === identifier);
            };
        },
    },

    actions: {
        async fetchList({commit}) {
            let data = await Vue.$api.get('/text/list');
            commit('setList', data);
        },

        async save({state, commit}, {id_text, content}) {
            let data = await Vue.$api.post(`/text/${id_text}`, {content});
            commit('setList', state.list.map(text => {
                return text.id_text === data.id_text ? data : text;
            }));
            if (data.identifier in state.texts) {
                commit('setText', {identifier: data.identifier, text: data.content});
            }
            return data;
        },
    },

};